<template>
	<CopyRightClaim />
</template>

<script>
import CopyRightClaim from "../screens/copy-right-claim";

export default {
	components: {
		CopyRightClaim
	}
};
</script>
